import { HALF_LIFE } from './config'

const ONE = 10n ** 18n
const LN2 = 693_147_180_559_945_309n

/**
 * value * 2^(-elapsed / HALF_LIFE), computed exactly the way Flatboard.decay does onchain,
 * so the page can keep heat ticking down between reads and still match the contract.
 */
export function decay(value: bigint, elapsed: bigint): bigint {
  if (elapsed < 0n) elapsed = 0n
  const halvings = elapsed / HALF_LIFE
  if (halvings >= 128n) return 0n
  value >>= halvings

  const y = ((elapsed % HALF_LIFE) * LN2) / HALF_LIFE
  const y2 = (y * y) / ONE
  const y3 = (y2 * y) / ONE
  const y4 = (y3 * y) / ONE
  const y5 = (y4 * y) / ONE
  const y6 = (y5 * y) / ONE
  const factor = ONE + y2 / 2n + y4 / 24n + y6 / 720n - y - y3 / 6n - y5 / 120n
  return (value * factor) / ONE
}

/** Seconds until `heat` (as of `now`) falls to half of what it is now. Always one half-life. */
export const secondsToHalf = (lastBoostAt: number, now: number) =>
  Number(HALF_LIFE) - ((now - lastBoostAt) % Number(HALF_LIFE))
